module.exports = __webpack_public_path__ + "img/preview.4a0133fa.png";